<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<form [formGroup]="assetDetailForm">
  <div class="inputBorder">
    <div class="row">
      <label class="ml-4">
        You are configuring data for external asset id: {{assetIds}}
      </label>
      <div class="col-md-12">
        <!-- <div class="col-md-3">
        <mat-form-field>
          <input type="text" formControlName="location_Id" placeholder="Location" matInput>
        </mat-form-field>
      </div> -->
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" formControlName="serial_number" placeholder="Serial Number" matInput>
          </mat-form-field>
        </div>
        <!-- <div class="col-md-3">
          <mat-form-field>
            <input type="text" formControlName="vin_number" placeholder="VIN" matInput>
          </mat-form-field>
        </div> -->
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" formControlName="make_year" placeholder="Year" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Make</mat-label>
            <mat-select matNativeControl formControlName="make_id">
              <ng-container *ngFor="let assetMake of assetMakes">
                <mat-option value="{{assetMake.categoryItemId}}">
                  {{assetMake.categoryCode}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" formControlName="vehical_model" placeholder="Model" matInput>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" formControlName="vehical_color" placeholder="Color" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput [matDatepicker]="inServiceDate" (focus)="inServiceDate.open()" formControlName="serviceDate"
              placeholder="In Service Date">
            <mat-datepicker-toggle matSuffix [for]="inServiceDate"></mat-datepicker-toggle>
            <mat-datepicker #inServiceDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput [matDatepicker]="activeSoldDate" (focus)="activeSoldDate.open()"
              formControlName="active_sold_date" placeholder="Active Sold Date">
            <mat-datepicker-toggle matSuffix [for]="activeSoldDate"></mat-datepicker-toggle>
            <mat-datepicker #activeSoldDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Leasing Company</mat-label>
            <mat-select matNativeControl formControlName="leasing_company">
              <ng-container *ngFor="let leasingCompany of leasingCompany">
                <mat-option value="{{leasingCompany.leasingCompanyId}}">
                  {{leasingCompany.leasingCompanyName}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Purchase Group</mat-label>
            <mat-select matNativeControl formControlName="purchase_group">
              <ng-container *ngFor="let purchaseGroup of purchaseGroups">
                <mat-option value="{{purchaseGroup.purchaseGroupId}}">
                  {{purchaseGroup.purchaseGroupName}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class=" col-md-3">
          <mat-form-field>
            <input type="text" placeholder="Asset Description (Related to Purchase Group)"
              formControlName="asset_description" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Equipment Vocation</mat-label>
            <mat-select matNativeControl formControlName="equipment_vocation">
              <ng-container *ngFor="let item of keyCodeList">
                <mat-option *ngIf="item.vmrs84KeyCode==1" value="{{item.vmrs84Id}}">
                  {{item.vmrs84CodeDescription}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Equipment Category</mat-label>
            <mat-select matNativeControl formControlName="equipment_category">
              <ng-container *ngFor="let item of keyCodeList">
                <mat-option *ngIf="item.vmrs84KeyCode==2" value="{{item.vmrs84Id}}">
                  {{item.vmrs84CodeDescription}} {{item.vmrs84Id}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-6">
          <mat-form-field>
            <textarea matInput placeholder="Detailed Description" formControlName="detailed_description"
              class="col-md-12"></textarea>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field>
            <textarea matInput placeholder="Hot Alert" formControlName="hot_alert" class="col-md-12"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" formControlName="license_number" placeholder="License" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>License State</mat-label>
            <mat-select matNativeControl formControlName="license_state">
              <ng-container *ngFor="let state of licenseState">
                <mat-option value="{{state.categoryItemId}}">
                  {{state.categoryCode}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput [matDatepicker]="licenseExpDate" (focus)="licenseExpDate.open()"
              formControlName="license_exp_date" placeholder="License Exp Date">
            <mat-datepicker-toggle matSuffix [for]="licenseExpDate"></mat-datepicker-toggle>
            <mat-datepicker #licenseExpDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Engine Size</mat-label>
            <mat-select matNativeControl formControlName="engine_size">
              <ng-container *ngFor="let engineSize of listEngineSizes">
                <mat-option value="{{engineSize.categoryItemId}}">
                  {{engineSize.categoryCode}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Asset Type Group</mat-label>
            <mat-select matNativeControl formControlName="asset_typeGroup">
              <ng-container *ngFor="let assetType of assetTypeGroups">
                <mat-option value="{{assetType.categoryItemId}}">
                  {{assetType.categoryCode}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Severity of Service</mat-label>
            <mat-select matNativeControl formControlName="severity_ofService">
              <ng-container *ngFor="let service of severityOfServices">
                <mat-option value="{{service.vmrs84Id}}">
                  {{service.vmrs84CodeDescription}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" placeholder="Avg Hrs Per Month" formControlName="avg_hrsPerMonth" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" placeholder="Avg Miles Per Month" formControlName="avg_milesPerMonth" matInput>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Body Style/Configuration</mat-label>
            <mat-select matNativeControl formControlName="body_styleConfiguration">
              <ng-container *ngFor="let bodyStyleConfiguration of bodyStyleConfigurations">
                <mat-option value="{{bodyStyleConfiguration.vmrs84Id}}">
                  {{bodyStyleConfiguration.vmrs84CodeDescription}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label> Engine Manufacturer</mat-label>
            <mat-select matNativeControl formControlName="engine_manufacturer">
              <ng-container *ngFor="let engineManufacturers of listEngineManufacturers">
                <mat-option value="{{engineManufacturers.categoryItemId}}">
                  {{engineManufacturers.categoryCode}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Axle Configuration</mat-label>
            <mat-select matNativeControl formControlName="axle_configuration">
              <ng-container *ngFor="let item of keyCodeList">
                <mat-option *ngIf="item.vmrs84KeyCode==3" value="{{item.vmrs84Id}}">
                  {{item.vmrs84CodeDescription}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Cab Type</mat-label>
            <mat-select matNativeControl formControlName="cab_type">
              <ng-container *ngFor="let item of keyCodeList">
                <mat-option *ngIf="item.vmrs84KeyCode==4" value="{{item.vmrs84Id}}">
                  {{item.vmrs84CodeDescription}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Power Source</mat-label>
            <mat-select matNativeControl formControlName="power_source">
              <ng-container *ngFor="let item of keyCodeList">
                <mat-option *ngIf="item.vmrs84KeyCode==5" value="{{item.vmrs84Id}}">
                  {{item.vmrs84CodeDescription}} ({{item.vmrs84Id}})
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Transmission Type</mat-label>
            <mat-select matNativeControl formControlName="transmission_type">
              <ng-container *ngFor="let item of keyCodeList">
                <mat-option *ngIf="item.vmrs84KeyCode==7" value="{{item.vmrs84Id}}">
                  {{item.vmrs84CodeDescription}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" placeholder="DOT Number" formControlName="dOT_number" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Trailer Length</mat-label>
            <mat-select matNativeControl formControlName="trailer_length">
              <ng-container *ngFor="let item of keyCodeList">
                <mat-option *ngIf="item.vmrs84KeyCode==13" value="{{item.vmrs84Id}}">
                  {{item.vmrs84CodeDescription}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Vehicle Status Code</mat-label>
            <mat-select matNativeControl formControlName="vehicle_statusCode">
              <ng-container *ngFor="let item of keyCodeList">
                <mat-option *ngIf="item.vmrs84KeyCode==20" value="{{item.vmrs84Id}}">
                  {{item.vmrs84CodeDescription}} ({{item.vmrs84Id}})
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Power Take Off</mat-label>
            <mat-select matNativeControl formControlName="power_takeOff">
              <ng-container *ngFor="let item of keyCodeList">
                <mat-option *ngIf="item.vmrs84KeyCode==36" value="{{item.vmrs84Id}}">
                  {{item.vmrs84CodeDescription}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Oil Type</mat-label>
            <mat-select matNativeControl formControlName="oil_type">
              <ng-container *ngFor="let item of oilTypeAsset">
                <mat-option *ngIf="item.categoryId==6" value="{{item.categoryItemId}}">
                  {{item.categoryCode}} ({{item.categoryItemId}})
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Asset Class</mat-label>
            <mat-select matNativeControl formControlName="asset_Class">
              <ng-container *ngFor="let item of oilTypeAsset">
                <mat-option *ngIf="item.categoryId==5" value="{{item.categoryItemId}}">
                  {{item.categoryCode}}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" placeholder="Life Cycle Expiration" formControlName="life_cycleExpiration" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" placeholder="Last Validated Mileage" formControlName="last_validatedMileage" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" placeholder="Current Assumed Mileage" formControlName="current_assumedMileage" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" placeholder="Last Validated Hours" formControlName="last_validatedHours" matInput>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <input type="text" placeholder="Current Assumed Hours" formControlName="current_assumedHours" matInput>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput [matDatepicker]="lastMileage" formControlName="last_mileage_update_date"
              (focus)="lastMileage.open()" placeholder="Last Mileage Update Date">
            <mat-datepicker-toggle matSuffix [for]="lastMileage"></mat-datepicker-toggle>
            <mat-datepicker #lastMileage></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput [matDatepicker]="lastHoursUpdateDate" formControlName="last_hours_update_date"
              (focus)="lastHoursUpdateDate.open()" placeholder="Last Hours Update Date">
            <mat-datepicker-toggle matSuffix [for]="lastHoursUpdateDate"></mat-datepicker-toggle>
            <mat-datepicker #lastHoursUpdateDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput [matDatepicker]="managedStartDate" formControlName="managed_startDate"
              (focus)="managedStartDate.open()" placeholder="Managed Start Date">
            <mat-datepicker-toggle matSuffix [for]="managedStartDate"></mat-datepicker-toggle>
            <mat-datepicker #managedStartDate></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-3">
          <mat-form-field>
            <input matInput [matDatepicker]="managedEndDate" formControlName="managed_endDate"
              (focus)="managedEndDate.open()" placeholder="Managed End Date">
            <mat-datepicker-toggle matSuffix [for]="managedEndDate"></mat-datepicker-toggle>
            <mat-datepicker #managedEndDate></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput [matDatepicker]="currentAssumedMiles" formControlName="current_assumed_miles_updated_date"
              (focus)="currentAssumedMiles.open()" placeholder="Current Assumed Miles Updated Date">
            <mat-datepicker-toggle matSuffix [for]="currentAssumedMiles"></mat-datepicker-toggle>
            <mat-datepicker #currentAssumedMiles></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput [matDatepicker]="currentAssumedHours" formControlName="current_assumed_hours_updated_date"
              (focus)="currentAssumedHours.open()" placeholder="Current Assumed Hours Updated Date">
            <mat-datepicker-toggle matSuffix [for]="currentAssumedHours"></mat-datepicker-toggle>
            <mat-datepicker #currentAssumedHours></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-md-1 mt-3">
          <mat-checkbox formControlName="is_managed">IsManaged</mat-checkbox>
        </div>
        <div class="col-md-2 mt-3">
          <mat-checkbox formControlName="state_inspection">State Inspection</mat-checkbox>
        </div>
      </div>
    </div>

    <div class="row">
    </div>
  </div>
</form>
<mat-dialog-actions align="end">
  <button (click)="dataSave()" class="btn btn-success btn-semi-round btn-demo pull-right ml-1"> Save </button>
</mat-dialog-actions>
